var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"clear":"both"}}),_c('div',{attrs:{"id":"html_content"},domProps:{"innerHTML":_vm._s(_vm.html_content)},on:{"click":function($event){return _vm.cb($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }